import { SegmentedControl, Select, Center } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { IconGenderFemale, IconGenderMale, IconGenderBigender } from '../../../icons';
import styles from './GenderSelect.module.css';

const DEFAULT_OPTIONS = [
    {
        value: 'Female',
        label: 'Female',
        icon: IconGenderFemale,
    },
    {
        value: 'Male',
        label: 'Male',
        icon: IconGenderMale,
    },
    {
        value: 'NonBinary',
        label: 'Non-binary',
        icon: IconGenderBigender,
    },
];

export const GenderSelect = ({
    value,
    onChange,
    error,
    options = DEFAULT_OPTIONS,
    fullWidth = true,
    renderAs = 'segmented',
    ...rest
}) => {
    const isMobile = useMediaQuery('(max-width: 48em)');

    if (renderAs === 'dropdown') {
        return (
            <Select
                value={value || null}
                onChange={onChange}
                error={error}
                data={options.map((opt) => ({ value: opt.value, label: opt.label }))}
                placeholder="Select"
                // A segmented control cannot be emptied once set: keep that behaviour.
                allowDeselect={false}
                {...rest}
            />
        );
    }

    const data = options.map((opt) => ({
        value: opt.value,
        label: isMobile ? (
            <span>{opt.label}</span>
        ) : (
            <Center style={{ gap: 8 }}>
                {opt.icon && <opt.icon size={18} stroke={1.5} />}
                <span>{opt.label}</span>
            </Center>
        ),
    }));

    return (
        <SegmentedControl
            value={value || ''}
            onChange={onChange}
            fullWidth={fullWidth}
            data={data}
            classNames={{
                root: `${styles.root} ${error ? styles.error : ''}`,
            }}
            {...rest}
        />
    );
};
